import { Svg } from './svg'

export const LogoutIcon = () => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 3C0 2.44772 0.447715 2 1 2C1.55228 2 2 2.44772 2 3V13C2 13.5523 1.55228 14 1
    14C0.447715 14 0 13.5523 0 13V3Z"
      fill="currentColor"
    />
    <path
      d="M7.41424 7L10.7071 3.70711C11.0977 3.31658 11.0977 2.68342 10.7071 2.29289C10.3166
    1.90237 9.68345 1.90237 9.29292 2.29289L3.58582 8L9.29292 13.7071C9.68345 14.0976 10.3166
    14.0976 10.7071 13.7071C11.0977 13.3166 11.0977 12.6834 10.7071 12.2929L7.41424 9H15C15.5523
    9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7H7.41424Z"
      fill="currentColor"
    />
  </Svg>
)
